// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3cqxG","notes":"Notes_notes__2uWXw"};